import React, { useState } from "react";

import { DoDisturbOn, ThumbDown, ThumbUp, TurnedIn, TurnedInNot } from "@mui/icons-material";
import { Typography } from "@mui/material";
import dayjs from "dayjs";
import { useSearchParams } from "react-router-dom";
import { useAddCommentFeedbackMutation } from "store/slices/commentSlice";

import { COMMENTS_TRENDS } from "../../constants";

const favorabilityIcons = {
  "Favorable": <ThumbUp className="!fill-green-600" fontSize="small" />,
  "Unfavorable": <ThumbDown className="!fill-red-600" fontSize="small" />,
  "Neutral": <DoDisturbOn className="!fill-gray-200" fontSize="small" />,
};

const sentimentIcons = {
  "positive": <ThumbUp className="!fill-green-600" fontSize="small" />,
  "negative": <ThumbDown className="!fill-red-600" fontSize="small" />,
  "neutral": <DoDisturbOn className="!fill-gray-200" fontSize="small" />,
};

const Comment = ({ comment, favorite, highlight, onLikeChange }) => {
  const [currentParams] = useSearchParams();
  const [like, setLike] = useState(Boolean(favorite));
  const [addComment] = useAddCommentFeedbackMutation();

  const trend = currentParams.get("trend") || COMMENTS_TRENDS.FAVORABILITY;

  const search = currentParams.get("search") || "";

  const handleLike = () => {
    if(!like) {
      setLike(true);
      addComment({
        commentId: comment.comment_id,
        likeType: "liked",
        searchTerm: search,
        comment: comment.comment,
        question: comment.question,
        division: comment.division,
        geo: comment.geo,
        managementLevel: comment.management_level,
        surveyDate: comment.survey_date,
        favorability: comment.favorability,
      });
      onLikeChange(comment.comment_id, true);
    } else {
      setLike(false);
      addComment({
        commentId: comment.comment_id,
        likeType: "unliked",
        searchTerm: search,
      });
      onLikeChange(comment.comment_id, false);
    }
    
  };

  const commentHtml = highlight ? comment.comment.replace(new RegExp(highlight, "gi"), match => `<span class="font-semibold bg-yellow-400">${match}</span>`) : comment.comment;

  return (
    <div className="pt-5 pb-3 flex gap-3 border-b border-gray-200 justify-between group cursor-pointer">
      <div className="flex-1">
        <div className="mb-2 flex justify-between items-center w-full">
          <div className="flex items-center gap-1">
            {trend === COMMENTS_TRENDS.FAVORABILITY ? favorabilityIcons[comment.favorability] : sentimentIcons[comment.sentiment]}
            <span className="capitalize">{trend === COMMENTS_TRENDS.FAVORABILITY ? comment.favorability : comment.sentiment}</span>
          </div>
          <div className="flex items-center gap-1">
            <Typography variant="body2" color="textSecondary">
              {dayjs(comment.survey_date).format("MMM 'YY")}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {comment.question}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {comment.geo} {comment.country}
            </Typography>
          </div>
        </div>
        <p dangerouslySetInnerHTML={{
          __html: commentHtml
        }} />
      </div>
      
      {like ?
        <TurnedIn className="!fill-blue-500 cursor-pointer" onClick={handleLike} /> :
        <TurnedInNot className="cursor-pointer invisible group-hover:visible
        " onClick={handleLike} />
      }
    </div>
  );
};

export default Comment;
